import React from "react";
import { PAYMENT_METHOD } from "../../constants/sharedConstans";

const ReceiptPrint = React.forwardRef(
  (
    {
      userName,
      address,
      cellphone,
      isPaid,
      paymentMethod,
      cashAmount,
      change,
      total,
    },
    ref
  ) => (
    <div ref={ref} className="receipt-print">
      <div className="invoice">
        <h5>
          <span className="fw-bold">Nombre: </span>
          {userName || "Cliente"}
        </h5>
        {cellphone && (
          <h5>
            <span className="fw-bold">Celular: </span>
            {cellphone}
          </h5>
        )}
        {address && (
          <h5>
            <span className="fw-bold">Dirección: </span>
            {address}
          </h5>
        )}

        <h5>
          <span className="fw-bold">Total: </span>
          {"$" + new Intl.NumberFormat("es-CL").format(total)}
        </h5>

        <h5>
          <span className="fw-bold">Estado de pago: </span>
          {isPaid ? "Pagado" : "Pendiente"}
        </h5>

        {!isPaid && (
          <h5>
            <span className="fw-bold">Método de pago: </span>
            {paymentMethod === PAYMENT_METHOD[0].id ? "Efectivo" : "Tarjeta"}
          </h5>
        )}

        {paymentMethod === PAYMENT_METHOD[0].id && !isPaid && (
          <>
            <h5>
              <span className="fw-bold">Monto a recibir: </span>
              {"$" + new Intl.NumberFormat("es-CL").format(cashAmount)}
            </h5>
            <h5>
              <span className="fw-bold">Vuelto: </span>
              {"$" + new Intl.NumberFormat("es-CL").format(change)}
            </h5>
          </>
        )}
      </div>
    </div>
  )
);

ReceiptPrint.displayName = "ReceiptPrint";

export default ReceiptPrint;
